<template>
  <div class="search-page">
    <TrainSearch/>
    <router-view></router-view>
  </div>
</template>

<script>
import TrainSearch from '../components/TrainSearch.vue';

export default {
  name: 'SearchPage',
  components: {
    TrainSearch,
  },
};
</script>
